module.exports = __webpack_public_path__ + "img/_3.f38574c0.png";